// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_qy","credits":"e_ry","badgeContainer":"e_sy","badge":"e_ty"};